import axios from 'axios';
import React, { useReducer, useState, useEffect, useRef } from 'react';
import { isUnauthorizedError } from '../lib/httpUtils';
import useInterval from "./../hooks/useInterval";
import Share from "./Share";
import L from 'leaflet';
import { isUserDisabled, redirectDisabledUser } from '../lib/userAccess';
import { syncControlPanelWindyPosition } from '../lib/controlPanelPosition';
import PlatformNavBar from './PlatformNavBar';
import { qcenterSvgIconUrl } from '../lib/platformNavigation';
import { detectClientPlatform } from '../lib/clientPlatform';
import { useTapBindings } from '../lib/useTapBindings';
import { setSessionUser } from '../lib/sessionActivity';

export default function AuthControllerWindy(props) {

    const { isMobile: isMob } = detectClientPlatform();
    const { bindTapEnd } = useTapBindings();

    const [isPortrait, setIsPortrait] = useState(window.matchMedia("(orientation: portrait)").matches);

    const [isHovered, setIsHovered] = useState(false);

    let touchStartTime;
    

    useEffect(() => {
        const handleOrientationChange = (event) => {
            //console.log("isPortrati : " + event.matches);
            if(event.matches){ // portrait
                const controlPanel = document.querySelector('.ControlPanelLateraleResponsive');
                if(controlPanel){
                    controlPanel.style.marginTop = '0px';
                }
            }
            else{ // landscape
                const controlPanel = document.querySelector('.ControlPanelLateraleResponsive');
                if(controlPanel){
                    controlPanel.style.marginTop = '0px';
                }
            }
            //console.log("orientation change");
          setIsPortrait(event.matches);
        };
    
        const mediaQuery = window.matchMedia("(orientation: portrait)");
        mediaQuery.addEventListener("change", handleOrientationChange);
    
        return () => {
          mediaQuery.removeEventListener("change", handleOrientationChange);
        };
      }, []);

    const _logga = (...any) => {
        // console.log("[htk][login]", ...any);
    }

    const logga = props.logger || _logga;

    let _csrfCookie = null;

    const [currentUser, setCurrentUser] = React.useState(
        JSON.parse(sessionStorage.getItem('loggedUser'))
    );

    const delay = 2000;
    const sessionCheckInFlightRef = useRef(false);

    const apiClient = axios.create({
        baseURL: props.apibase,
        withCredentials: true,
    })

    const userSave = (userData) => {
        
        _logga("userdata found:", userData);
        let curUser = null;
        
        if (userData) {
            _logga("current user:", userData.email);
            curUser = {
                email: userData.email,
                name: userData.name,
                surname: userData.surname,
                completeName: userData.name + " " + userData.surname
            };
            props._fnUserTipo(userData.tipo);
        }

        setSessionUser(curUser);

        if (curUser != currentUser) {
            _logga("Login status changed to", curUser)
            props.onLoginToggle(curUser);
            //props.onUserChange(curUser); // passaggio del valore dell'utente alla componente padre
            setCurrentUser(curUser)
            sessionStorage.setItem('loggedUser', JSON.stringify(curUser));
        }
    }

    const _userSessionCheck = () => {
        if (sessionCheckInFlightRef.current) {
            return;
        }

        logga("Checking user session")

        if (props.accessMode) {
            logga("Utente guest code");
            userSave({
                email: 'guest@hightek.it',
                name: 'Guest'
            });
            return;
        }

        sessionCheckInFlightRef.current = true;

        // controllare se viene forzato il render a cause di useState
        apiClient.get('/testing/json/user')
            .then((response) => {
                if (response.status !== 200) {
                    throw "user session not found";
                }

                if (isUserDisabled(response.data)) {
                    redirectDisabledUser(props.apibase);
                    return;
                }

                logga("Utente loggato:", response.data.email)
                userSave(response.data)
            })
            .catch((error) => {
                logga("Errore: ", error);
                if (isUnauthorizedError(error)) {
                    userSave(null);
                }
            })
            .finally(() => {
                sessionCheckInFlightRef.current = false;
            })
    }

    const _tokenGet = async () => {
        if (!_csrfCookie) {
            logga("CSRF Token not set, searching in cookies..")
            _csrfCookie = document.cookie
                .split('; ')
                .find(row => row.startsWith('XSRF-TOKEN='))
        }

        if (!_csrfCookie) {
            logga("CSRF Cookie not found, requesting CSRF Token", `${props.apibase}/sanctum/csrf-cookie`)
            apiClient.get('/sanctum/csrf-cookie').then(() => {
                logga("Setting cookie");
                _tokenGet();
            }).catch(err => {
                logga("Error obtaining token", err);
            })
            return
        }

        logga("_csrfCookie is", _csrfCookie.split('=')[1])
    }

    const loginLaunch = (e) => {
        _tokenGet()
        // _logga("login api base", props.apibase, props.apibase.trimEnd('/'));
        const loginPage = props.apibase.replace(/\/+$/, '') + `/login?htk_redirect=${window.location.href}`;
        window.location.href = loginPage;
    }

    function handleTouchStart() {
        touchStartTime = new Date().getTime();
    }

    function handleTouchEnd(event) {
        const touchEndTime = new Date().getTime();
        const touchDuration = touchEndTime - touchStartTime;
        
        if (touchDuration < 200) { // Tempo massimo per considerare un tocco come clic
            //console.log("Tocco eseguito");
            onTouchMissions(event);
        }
    }

    function handleTouchStartUser() {
        touchStartTime = new Date().getTime();
    }

    function handleTouchEndUser(event) {
        const touchEndTime = new Date().getTime();
        const touchDuration = touchEndTime - touchStartTime;
        
        if (touchDuration < 200) { // Tempo massimo per considerare un tocco come clic
            //console.log("Tocco eseguito");
            onTouchMissionsUser(event);
        }
    }

    const onTouchMissions = (event) => {
        event.preventDefault();
        //console.log("NUMERO CLICK")
        window.open(props.htkBackend + "/missioni");
      };

      const onTouchMissionsUser = (event) => {
        event.preventDefault();
        //console.log("NUMERO CLICK")
        window.open(props.assetsBase + "/");
      };
        
    useEffect(() => {
        _userSessionCheck();

        const handleResize = () => syncControlPanelWindyPosition();
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useInterval(_userSessionCheck, delay);

    const closePanelResp = () => {
        const navbar = document.querySelector('.barraNavigazioneWindy');
        if(navbar){
            navbar.style.transition = 'margin-top 0.5s ease'; // Aggiungi l'effetto di transizione
            const altezzaNavbar = navbar.offsetHeight;
            navbar.style.marginTop = `-${altezzaNavbar}px`;
        }

        setTimeout(() => {
            const bottone = document.querySelector('.contenitoreIcona2Resp');
            if(bottone){
                bottone.classList.remove('invisible');
                bottone.classList.add('visible');
            }
        }, 50);
    }


    const openPanelResp = () => {
        const navbar = document.querySelector('.barraNavigazioneWindy');
        if(navbar){
            navbar.style.transition = 'margin-top 0.5s ease'; // Aggiungi l'effetto di transizione
            navbar.style.marginTop = '0px';
        }

        const bottone = document.querySelector('.contenitoreIcona2Resp');
        if(bottone){
            bottone.classList.remove('visible');
            bottone.classList.add('invisible');
        }
    }

    const handleMouseEnter = () => {
        setIsHovered(true);
      };
    
      const handleMouseLeave = () => {
        setIsHovered(false);
      };

      function resizeWindow() {
        const resizeEvent = window.document.createEvent("UIEvents");
        resizeEvent.initUIEvent("resize", true, false, window, 0);
        window.dispatchEvent(resizeEvent);
    }

      const cambiaMappa = () => {

        const mappaEarth = document.querySelector('gmp-map-3d');

        if (mappaEarth) {
            const center = mappaEarth.getAttribute('center');
            const range = mappaEarth.getAttribute('range');
            
            // const bounds = mappaEarth.getAttribute('bounds');
            // console.log("bounds google 3d : " + bounds);

            if (center) {
                const [lat, lng, altitude] = center.split(',').map(Number);
               //console.log(`Parametri dalla mappa Google (Center): lat=${lat}, lng=${lng}, altitude=${altitude}, range=${range}`);

                let rangeNum = parseFloat(range);

                // definire una mappatura al contrario che , partendo da altitude/range ricavi lo zoom

                const rangeToZoom = [
                    { range: 66874361, zoom: 0},
                    { range: 33074361, zoom: 1},
                    { range: 16874361, zoom: 2},
                    { range: 8874361, zoom: 3},
                    { range: 7437177, zoom: 4},
                    { range: 4718585, zoom: 5},
                    { range: 2359289, zoom: 6},
                    { range: 1179641, zoom: 7},
                    { range: 589817, zoom: 8},
                    { range: 294905, zoom: 9},
                    { range: 147449, zoom: 10},
                    { range: 73721, zoom: 11},
                    { range: 35857, zoom: 12},
                    { range: 18425, zoom: 13},
                    { range: 9209, zoom: 14},
                    { range: 4601, zoom: 15},
                    { range: 2297, zoom: 16},
                    { range: 1145, zoom: 17},
                    { range: 569, zoom: 18},
                    { range: 281, zoom: 19},
                    { range: 137, zoom: 20},
                    { range: 65, zoom: 21},
                    { range: 29, zoom: 22}
                ];

                function generateRangeIntervals(rangeToZoom) {
                    const newZoomToRange = [];
                    const steps = 10;
                
                    for (let i = 0; i < rangeToZoom.length - 1; i++) {
                        const current = rangeToZoom[i];
                        const next = rangeToZoom[i + 1];
                
                        const zoomStep = (next.zoom - current.zoom) / steps;
                        const rangeStep = (next.range - current.range) / steps;
                
                        for (let j = 0; j < steps; j++) {
                            newZoomToRange.push({
                                range: parseFloat((current.range + rangeStep * j).toFixed(1)),
                                zoom: parseFloat((current.zoom + zoomStep * j).toFixed(1))
                            });
                        }
                    }
                
                    // Add the last item
                    newZoomToRange.push(rangeToZoom[rangeToZoom.length - 1]);
                
                    return newZoomToRange;
                }
                
                const newRangeToZoom = generateRangeIntervals(rangeToZoom);
                //console.log("NEW RANGE : " + JSON.stringify(newRangeToZoom));

                function getLeafletZoomFromRange(range) {
                    // Cerca il range corrispondente
                    for (let i = 0; i < newRangeToZoom.length; i++) {
                        if (range >= newRangeToZoom[i].range) {
                            return newRangeToZoom[i].zoom;
                        }
                    }
                    // Se il range è più piccolo del minimo valore nella mappatura, ritorna il massimo livello di zoom
                    return newRangeToZoom[newRangeToZoom.length - 1].zoom;
                }

                // let zoomLevel = getZoomLevelForRange(altitudeRange.toFixed(0));
                let zoomLevel = getLeafletZoomFromRange(rangeNum.toFixed(0));

               //console.log("Zoom Level calcolato di conseguenza:", zoomLevel);

               //console.log("FINE LOG GOOGLE.........");

                // Verifica che `props.map` sia definito e quindi usa `map` per aggiornare la vista della mappa
                if (props.mappaLeaflet) {
                    props.mappaLeaflet.setView(new L.LatLng(lat, lng), zoomLevel);
                } else {
                    console.error("Mappa Leaflet non definita.");
                }

            } else {
                console.error("Attribute 'center' is not defined.");
            }
        } else {
            console.error("Map object is not defined.");
        }

        const controlPanelWindy = document.querySelector(".ControlPanelWindy");
        if(controlPanelWindy){
            controlPanelWindy.style.setProperty("display", "none", "important");
        }
        const infoBoxWindy = document.querySelector(".FlyInfoPanelContainerWindy");
        if(infoBoxWindy){
            infoBoxWindy.style.setProperty("display", "none", "important");
        }

        const authHeaderWindy = document.querySelector(".barraNavigazioneWindy");
        authHeaderWindy.style.setProperty("display", "none", "important");

        const authHeaderGoogle = document.querySelector(".barraNavigazione");
        authHeaderGoogle.style.display = "block";


        // cambio mappa

        const mappaGoogle = document.querySelector(".mappaGoogle");
        mappaGoogle.style.display = "block";

        const mappaWindyStyle = document.getElementById("mappaGoogle3D");
        mappaWindyStyle.style.display = "none";

        props.setMappaLeafletProps();

    };

      const openPanelWindy = () => {
        //console.log("open panel authWindy.js");

        const navbar = document.querySelector('.barraNavigazioneWindy');
        if(navbar){
            navbar.style.transition = 'margin-top 0.5s ease'; // Aggiungi l'effetto di transizione
            navbar.style.marginTop = '0px';
        }

        const bottone = document.querySelector('.contenitoreIcona2Windy');
        if(bottone){
            bottone.classList.remove('visible');
            bottone.classList.add('invisible');
        }

        syncControlPanelWindyPosition();
    }
    
    const closePanelWindy = () => {
        //console.log("close panel authWindy.js");

        const navbar = document.querySelector('.barraNavigazioneWindy');
        if(navbar){
            navbar.style.transition = 'margin-top 0.5s ease'; // Aggiungi l'effetto di transizione
            const altezzaNavbar = navbar.offsetHeight;
            navbar.style.marginTop = `-${altezzaNavbar}px`;
        }

        syncControlPanelWindyPosition();

        setTimeout(() => {
            const bottone = document.querySelector('.contenitoreIcona2Windy');
            if(bottone){
                bottone.classList.remove('invisible');
                bottone.classList.add('visible');
            }
            syncControlPanelWindyPosition();
        }, 510);
    }

    if (currentUser) {
        const mapSwitchTo2D = (
            <div className="nav-item d-flex align-items-center platform-nav-item">
                <button
                    type="button"
                    className="nav-link platform-nav-link border-0 bg-transparent"
                    onClick={cambiaMappa}
                    title="Passa a Google 2D"
                >
                    <img
                        className="platform-nav-svg-icon platform-nav-map-switch-icon"
                        src={qcenterSvgIconUrl(props.htkBackend, 'map.svg')}
                        alt=""
                        aria-hidden="true"
                    />
                    <span className="d-none d-xl-inline">Google 2D</span>
                </button>
            </div>
        );

        return (
            <>
                {!isMob  && //isNavbarOpen && Mostra la barra dell'intestazione solo su schermi larghi o in modalità landscape su dispositivi mobili
                    (
                        <>
                        <nav id="containerNavBarWindy" className="navbar navbar-expand-md navbar-light bg-white shadow-sm navBarSystem barraNavigazioneWindy" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                            <div className="container position-relative">
                                <PlatformNavBar
                                    htkBackend={props.htkBackend}
                                    userTipo={props.userTipo}
                                    currentUser={currentUser}
                                    assetsBase={props.assetsBase}
                                    extraActions={mapSwitchTo2D}
                                />
                            </div>
                            <div className="navbar-chevron-bar position-absolute" style={{ bottom: 0, left: 0, right: 0, display: 'flex', justifyContent: 'center' }}>
                                <div className={`divContainerButtSeleziona2 contenitoreIconaWindy contenitoreIcona-centered ${isHovered ? 'visible' : 'invisible'}`} onClick={closePanelWindy}>
                                    <div className="fas fa-2x fa-chevron-up iconaFreccia"></div>
                                </div>
                            </div>
                        </nav>
                        <div
                            className="divContainerButtSeleziona2 contenitoreIcona2Windy invisible"
                            style={{
                                position: 'fixed',
                                top: 0,
                                left: '50%',
                                transform: 'translateX(-50%)',
                                marginLeft: 0,
                                zIndex: 3000,
                            }}
                            onClick={openPanelWindy}
                            title="Apri pannello autenticazione"
                        >
                            <div className="fas fa-2x fa-chevron-down iconaFreccia2"></div>
                        </div>
                        </>
                    ) 
                }

                {isMob && isPortrait && // Mostra la barra dell'intestazione solo su schermi stretti e in modalità portrait su dispositivi mobili
                                (
                                    <>
                                    <nav id="containerNavBarWindy" className="navbar navbar-light bg-white shadow-sm navBarSystemPortrait barraNavigazioneWindy">
                                        <div className="container">
                                            <PlatformNavBar
                                                htkBackend={props.htkBackend}
                                                userTipo={props.userTipo}
                                                currentUser={currentUser}
                                                assetsBase={props.assetsBase}
                                                compact
                                            />
                                        </div>
                                        <div className="navbar-chevron-bar position-absolute" style={{ bottom: 0, left: 0, right: 0, display: 'flex', justifyContent: 'center' }}>
                                            <div className="divContainerButtSeleziona2 contenitoreIcona contenitoreIcona-centered contenitoreIconaResp dimensioniIconaApri" {...bindTapEnd(closePanelResp)}>
                                                <div className="fas fa-1x fa-chevron-up iconaFrecciaResp"></div>
                                            </div>
                                        </div>
                                    </nav>
                                    <div
                                        className="divContainerButtSeleziona2 contenitoreIcona2Resp invisible dimensioniIconaChiudi"
                                        style={{
                                            position: 'fixed',
                                            top: 0,
                                            left: '50%',
                                            transform: 'translateX(-50%)',
                                            marginLeft: 0,
                                            zIndex: 3000,
                                        }}
                                        {...bindTapEnd(openPanelResp)}
                                    >
                                        <div className="fas fa-1x fa-chevron-down iconaFreccia2Resp"></div>
                                    </div>
                                    </>
                                ) 
                }

            {isMob && !isPortrait /*&& // Mostra la barra dell'intestazione solo su schermi stretti e in modalità portrait su dispositivi mobili
                                (
                                    <>
                                    <nav className="navbar navbar-light bg-white shadow-sm navBarSystemPortrait barraNavigazioneWindy">
                                        <div className="d-flex flex-row align-items-center container">

                                                <div className="d-flex flex-row align-items-center text-primary">
                                                    <img src={props.htkBackend + "/brand/QWEB.png"} className="imgQwebHeader1"/>
                                                </div>
                                                
                                                <div className="d-flex flex-row align-items-center text-primary">
                                                    <img className="imgQwebHeader" src="/brandIcons/MISSIONI.png"  /> 
                                                    <a className="btn btn-gray" target="_blank" onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd}>Missions</a>
                                                </div>
                                                
                                                <div className="d-flex flex-row align-items-center text-primary">
                                                    <img className="imgQwebHeader" src="/brandIcons/USERS.png" /> 
                                                    <a className="btn btn-gray" target="_blank" onTouchStart={handleTouchStartUser} onTouchEnd={handleTouchEndUser}>{currentUser.completeName}</a>
                                                </div>
                                        </div>
                                        <div className="divContainerButtSeleziona2 position-absolute start-50 translate-middle contenitoreIconaResp dimensioniIconaApri" style={{ bottom: '0', transform: 'translateX(-31px)' }} onTouchEnd={closePanelResp}>
                                            <div className="fas fa-1x fa-chevron-up iconaFrecciaResp"></div>
                                        </div>
                                    </nav>
                                    <div className="divContainerButtSeleziona2 position-absolute start-50 translate-middle contenitoreIcona2Resp invisible dimensioniIconaChiudi" style={{top: '0', transform: 'translateX(-16px)' }} onTouchEnd={openPanelResp}>
                                        <div className="fas fa-1x fa-chevron-down iconaFreccia2Resp"></div>
                                    </div>
                                    </>
                                ) */
                }

            </>
        )
    } else {
        return (
                <>
                    <nav className="navbar navbar-expand-md navbar-light bg-white shadow-sm navBarSystem">
                        <div className="d-flex flex-row align-items-center w-100 container">
                            <div className=""><img src={props.assetsBase + "/brand/QWEB.png"} width="40" /></div>
                            <div className="ms-auto d-flex flex-row">
                                <h5>Per utilizzare q-live è necessario autenticarsi</h5>
                                <button type="button" onClick={loginLaunch}>
                                    Autenticami
                                </button>
                            </div>
                        </div>
                    </nav>
                </>
        )
    }
}